import { ChangeDetectorRef, Component } from '@angular/core';
import { PlanAniosService } from '../../services/plan-anios.service';
import { IpPublicService } from 'src/app/services/ip-public.service';
import { AlertService } from 'src/app/services/alert.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ModalService } from 'src/app/services/modal.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject, forkJoin, map } from 'rxjs';
import { AniosObjetivosService } from '../../services/anios-objetivos.service';
import { AniosService } from '../../services/anios.service';

@Component({
  selector: 'app-anios',
  templateUrl: './anios.component.html',
  styleUrls: ['./anios.component.css'],
})
export class AniosComponent {

  breadCrumbItems = [{label: 'Administración Proceso'}, {label: 'Gestión Planes'}, {label: 'Gestion Años', active: true}];

  public mostrarModal: boolean = false;
  public dataCatalogoAnios:any=[];
  public formSubmitted = false;
  public formAnios!: FormGroup;
  public dataPlanIns!: any;
  public dataAnios: any = [];
  public dataPlanesInst: any = [];
  public dataPlanAnios: any = [];
  public dataAniosPlanInst: any = [];
  public idSprUsuario: any;
  public ipAddress!: string;
  public dataAniosSelect: any = [];
  public selectPlan: number = 0;
  public anioInicio!: number;
  public anioFin!: number;
  public fecha: string = '2022-01-01';
  public idSprAmbiente: any;
  public currentAmbiente: any;
  filtroPost = '';
  descriptionApp = localStorage.getItem('descriptionApp');
  buffer!: any;
  currentUser!: any;
  private idDeleteRegister: number = 0;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  public nameModal: string = 'modalNewEdit';
  isDtInitialized: boolean = false;
  dtElement: DataTableDirective;
  public nameApp = 'Gestión años';
  namePlanAnios= 'GESTION AÑOS'
  isSubmitted = false;
  public estadoActivo: number = 1;

  public fechaInicioDate: any;
  public fechaFinDate: any;


  constructor(
    private fb: FormBuilder,
    private aniosService: AniosService,
    private ip: IpPublicService,
    private alert: AlertService,
    public modal: ModalService,
    private cdRef: ChangeDetectorRef,
    private planAniosService:AniosObjetivosService,
  


  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.idSprAmbiente = this.currentUser.idSprAmbiente;
    this.currentAmbiente = JSON.parse(this.buffer);
  }

  ngOnInit() {
    this.getIpPublic();
    this.initApp();
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  initApp() {
    this.setDataTable();
    this.setForm();
    //this.getPlanAnios();
    this.lisDataAnios();

  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  setForm() {
    this.formAnios = this.fb.group({
      idSprAnio: [0], 
      anio: ['', [Validators.required]],

      estado: ['', [Validators.required]],
    });
  }

  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }



  selectPlanAnio(event: any, dataPlanIns: any[]) {


      let planInstitu = dataPlanIns.filter((plan: any) => {
      return +plan.idSprPlanInstitucional === +event;

    });
    let anioInicial = +planInstitu[0].fechaInicio.slice(0, 4);
    let anioFin = +planInstitu[0].fechaFin.slice(0, 4);
    let aniosPlan = [];

    while (anioInicial <= anioFin) {
      aniosPlan.push(anioInicial);
      anioInicial++;
    }
    this.dataAniosSelect = aniosPlan;
  }

  validacionFechas(fechaInicio: Date, fechaFin: Date) {
    let alerta1
    if ((fechaInicio < this.fechaInicioDate) ||(fechaInicio > this.fechaFinDate)) {
      alerta1 = this.alert.warning(
        '¡Atención!',
        'La fecha inicio debe estar dentro del periodo seleccionado.'
      );
    }
    if ((fechaFin < this.fechaInicioDate) || (fechaFin > this.fechaFinDate)) {
      alerta1 = this.alert.warning(
        '¡Atención!',
        'La fecha fin debe estar dentro del periodo seleccionado.'
      );
    }

    if (fechaInicio > fechaFin ) {
      alerta1 = this.alert.fechaError();
    }

  }

  createPlanAnios() {
    //this.validacionFechas(fechaInicio, fechaFin);
    this.formSubmitted = true;
    this.isSubmitted = true;
    this.formAnios.value.usuario = this.currentUser.idSprUsuario;
    this.formAnios.value.ip = this.ipAddress;
    this.formAnios.value.delLog = 'N';
      if (this.formAnios.value.idSprAnio == null || this.formAnios.value.idSprAnio == '') {
        this.aniosService.create(this.formAnios.value).subscribe(
          (resp) => {
            this.closeModal();
            this.initApp();

            this.alert.createOk();
          },
          (err) => {

          }
        );
      } else {
        this.aniosService.update(this.formAnios.value).subscribe(
          (resp) => {
            this.isSubmitted = true;
            this.closeModal();
            this.initApp();
            this.alert.updateOk();
          },
          (err) => {
            this.alert.updateError();

          }
        );
      }
      return false;
   
  }


  editAnios(obj: any) {
    this.modal.open(this.nameModal);
    this.formAnios.patchValue({
      idSprAnio: obj.idSprAnio,
      anio: obj.anio,
      estado: obj.estado,

    });

  }




lisDataAnios(){
    forkJoin([  
      this.aniosService.list(),     
    ]).pipe(map(([anios]) => {
        this.dataAnios=anios;
      })).subscribe();
}

  // Modal Crear/editar

  openModal() {
    this.onResetForm();
    this.modal.open(this.nameModal);
  }

  onResetForm() {
    this.formSubmitted = false;
    this.formAnios.reset();
  }

  closeModal() {
    this.modal.close();
  }

   verifyPalnAnio(){
     return this.planAniosService.list(`?idSprAnio=${this.idDeleteRegister}&delLog=N`).toPromise();
 }


async confirmDelete() {
  let confirmDelete = true;
  let dataVerifyRelacion: any = [];
    //##############  verificacion1 si existe datos relacionado ########################
    dataVerifyRelacion =  await this.verifyPalnAnio();
    (dataVerifyRelacion.length > 0 ) ? confirmDelete = false : "";
   //###################################################################################

    if (confirmDelete) {
           this.aniosService.delete({
          idSprAnio: this.idDeleteRegister,
          usuario: this.currentUser.idSprUsuario,
          delLog: 'S',
          ip: this.ipAddress,
        })
        .subscribe(
          (resp) => {
            //this.getPlanAnios();
            this.alert.deleteOk();
            this.initApp();
            this.modal.closeId('deleteAnios');
          },
          (err) => {
            this.alert.deleteError();
          }
        );
    } else{
      this.alert.EliminarRegistro();}
      this.modal.closeId('deleteAnios')
  }

  deleteAnios(idRegister: number) {
    this.modal.open('deleteAnios');
    this.idDeleteRegister = idRegister;
  }
}
